import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IKeyInvestmentConsiderationsItems {
	/**
	 * Item Label
	 */
	label?: string;
}

export interface IKeyInvestmentConsiderationsProps
	extends IBaseElementProps {
	/**
	 * Key Investment Considerations Heading
	 */
	heading?: string;
	/**
	 * Key Investment Considerations Items
	 */
	items?: IKeyInvestmentConsiderationsItems[];
}

/**
 * Key Investment Considerations
 * @block
 * @icon saved
 */
const KeyInvestmentConsiderations: React.FC<IKeyInvestmentConsiderationsProps> =
	({ heading, items = [], id, className, classNames = [] }) => (
		<div
			id={id}
			className={
				className ||
				cn('calian-key-investment-considerations', ...classNames)
			}
		>
			<h4 className="calian-key-investment-considerations__heading">
				{heading}
			</h4>
			<ul className="calian-key-investment-considerations__items">
				{items.length > 0 &&
					items.map(
						({ label }, index) =>
							label && (
								<li
									className="calian-key-investment-considerations__item"
									key={index}
								>
									<span className="calian-key-investment-considerations__icon icon icon-check"></span>
									{label}
								</li>
							),
					)}
			</ul>
		</div>
	);

export default KeyInvestmentConsiderations;
